import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../components/Logo';
import { clearSession } from '../auth/session';

type InactiveAccount = { username?: string; email?: string; fullName?: string };

export default function InactiveAccountPage() {
  const { t } = useTranslation();
  let account: InactiveAccount = {};
  try {
    account = JSON.parse(sessionStorage.getItem('inactiveAccount') || '{}');
  } catch {
    account = {};
  }
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || 'inventorygeek1@gmail.com';
  const displayName = account.fullName || account.username || account.email;

  const returnToLogin = () => {
    sessionStorage.removeItem('inactiveAccount');
    clearSession();
  };

  return (
    <main style={{ minHeight: '100vh', padding: '32px 18px', display: 'grid', placeItems: 'center', background: 'radial-gradient(circle at top, #eaf2ff 0, #f7f9fc 45%, #eef1f5 100%)' }}>
      <section style={{ width: '100%', maxWidth: 590, overflow: 'hidden', background: '#fff', borderRadius: 22, boxShadow: '0 18px 60px rgba(16,24,40,.14)', border: '1px solid #e4e7ec' }}>
        <div style={{ padding: '34px 32px 28px', color: '#fff', textAlign: 'center', background: 'linear-gradient(135deg,#123a72,#2563eb)' }}>
          <div style={{ width: 82, height: 82, margin: '0 auto 18px', padding: 13, boxSizing: 'border-box', background: '#fff', borderRadius: 22, boxShadow: '0 8px 25px rgba(0,0,0,.18)' }}>
            <Logo width="100%" height="100%" />
          </div>
          <div style={{ display: 'inline-block', padding: '5px 11px', marginBottom: 12, borderRadius: 999, background: 'rgba(255,255,255,.16)', fontSize: 12, fontWeight: 800, letterSpacing: '.08em', textTransform: 'uppercase' }}>
            {t('inactiveAccount.status')}
          </div>
          <h1 style={{ margin: 0, fontSize: 29 }}>{t('inactiveAccount.title')}</h1>
        </div>

        <div style={{ padding: '30px 32px 34px' }}>
          {displayName && <p style={{ margin: '0 0 10px', color: '#344054', fontWeight: 700, textAlign: 'center' }}>{t('inactiveAccount.hello', { name: displayName })}</p>}
          <p style={{ margin: '0 auto', maxWidth: 470, color: '#667085', lineHeight: 1.65, textAlign: 'center' }}>{t('inactiveAccount.description')}</p>

          <div style={{ margin: '24px 0', padding: 17, display: 'flex', gap: 13, alignItems: 'flex-start', borderRadius: 13, background: '#fff8e7', border: '1px solid #fedf89' }}>
            <span aria-hidden="true" style={{ fontSize: 22 }}>🔒</span>
            <div><strong style={{ color: '#93370d' }}>{t('inactiveAccount.dataSafe')}</strong><div style={{ marginTop: 4, color: '#7a2e0e', fontSize: 14, lineHeight: 1.5 }}>{t('inactiveAccount.dataSafeHelp')}</div></div>
          </div>

          {(account.username || account.email) && (
            <div style={{ padding: 16, marginBottom: 24, borderRadius: 12, background: '#f8fafc', color: '#475467', fontSize: 14 }}>
              {account.username && <div><strong>{t('common.username')}:</strong> {account.username}</div>}
              {account.email && <div style={{ marginTop: account.username ? 7 : 0 }}><strong>{t('common.email')}:</strong> {account.email}</div>}
            </div>
          )}

          <div style={{ display: 'grid', gap: 11 }}>
            <a href={`mailto:${supportEmail}?subject=${encodeURIComponent('StockFlow account reactivation')}`} style={{ padding: '13px 18px', textAlign: 'center', borderRadius: 10, background: '#1976d2', color: '#fff', fontWeight: 700, textDecoration: 'none' }}>
              {t('inactiveAccount.contactSupport')}
            </a>
            <Link to="/login" onClick={returnToLogin} style={{ padding: '12px 18px', textAlign: 'center', borderRadius: 10, border: '1px solid #d0d5dd', color: '#344054', fontWeight: 700, textDecoration: 'none', background: '#fff' }}>
              {t('inactiveAccount.backToLogin')}
            </Link>
          </div>
          <p style={{ margin: '20px 0 0', textAlign: 'center', fontSize: 13, color: '#98a2b3' }}>{t('inactiveAccount.supportEmail', { email: supportEmail })}</p>
        </div>
      </section>
    </main>
  );
}
